<div class="banner"
  *transloco="let t; lang: 'en|static' read: 'registry_ppdm_org.banner'">

  <div class="content">
    <nav role="navigation"
      [attr.aria-label]="t('aria_navigation_links')">
      <ul>
        <li>
          <a href="https://ppdm.org/ppdm/PPDM/Home/PPDM/Home.aspx"
            target="_blank">{{ t('home') }}</a>
        </li>
        <li>
          <a href="https://ppdm.org/ppdm/PPDM/About_Us/PPDM/About_Us.aspx"
            target="_blank">{{ t('about_us') }}</a>
        </li>
        <li>
          <a href="https://ppdm.org/ppdm/PPDM/Collaboration/PPDM/Collaboration/Collaboration.aspx?hkey=69ae5f30-95aa-45d6-8bcf-28d336ee8481"
            target="_blank">{{ t('collaboration') }}</a>
        </li>
        <li>
          <a href="https://ppdm.org/ppdm/PPDM/events_list/PPDM/Events.aspx"
            target="_blank">{{ t('events') }}</a>
        </li>
        <li>
          <a href="https://ppdm.org/ppdm/PPDM/IEDS/PPDM/IEDS.aspx?hkey=fcd52d61-9bd5-4f27-9c91-a4b9fda3d2e8"
            target="_blank">{{ t('ieds') }}</a>
        </li>
        <li>
          <a href="https://ppdm.org/ppdm/PPDM/PPDM_Membership/PPDM/Membership.aspx"
            target="_blank">{{ t('membership') }}</a>
        </li>
        <li>
          <a href="https://ppdm.org/ppdm/PPDM/Professional_Development/PPDM/Professional_Development"
            target="_blank">{{ t('professional_development') }}
          </a>
        </li>
        <li>
          <a href="https://ppdm.org/ppdm/PPDM/resources/PPDM/Resources.aspx"
            target="_blank">{{ t('resources') }}</a>
        </li>
        <li>
          <a href="https://ppdm.org/ppdm/PPDM/Volunteer/PPDM/Volunteer/Volunteer.aspx?hkey=07a2b2bd-0c6b-4eba-900f-96914d6d959c"
            target="_blank">{{ t('volunteer') }}</a>
        </li>
      </ul>
    </nav>
  </div>
</div>
